import React, { useState } from 'react';
import './projects.css'
import eiendomsmegler1Logo from '../assets/images/eiendomsmegler1_logo_1200x630.jpg';
import salesreportpreview from '../assets/images/salesreportpreview.png';
import examinerlogo from '../assets/images/2ndexaminerlogo.png';
import examinerPreview from '../assets/images/2ndExaminer.png';
import smartDisplay from '../assets/images/smartDisplay.png';
import smartDisplayPreview from '../assets/images/project_3.jpg';
import ProjectDetails from './ProjectDetails';


function Projects() {
  const [selectedProject, setSelectedProject] = useState(null);
  const projects = [
    {
      name: "Modernized sales reports",
      logo: eiendomsmegler1Logo,
      alt: "eiendomsmegler1",
      id: "eiendomsmegler1Logo",
      link: "https://bachelor-eiendomsmegler1.firebaseapp.com/",
      img: salesreportpreview,
      details: "In this project, our primary objective was to revamp the sales reports for Eiendomsmegler 1, with a strong emphasis on modernization. Through our research, we discovered that lengthy PDF documents often pose challenges when it comes to readability. As a result, we undertook a comprehensive restructuring of the sales report format to enhance presentation and user experience."
    },
    {
      name: "2ndExaminer",
      logo: examinerlogo,
      alt: "examinerlogo",
      id: "examinerlogo",
      link: "https://examinerapp-325c3.web.app/",
      img: examinerPreview,
      details: "In this project, our main focus was to develop a user-friendly system for teachers to facilitate the process of applying for and assigning second examiners. Recognizing the importance of efficiency and simplicity, we worked diligently to create a streamlined interface that allows teachers to easily submit requests, apply for specific requests, and visualize relevant information. Our aim was to simplify the overall process and provide a seamless experience for all users involved."
    },
    {
      name: "Smart display at Mustad",
      logo: smartDisplay,
      alt: "smartDisplay",
      link: "https://www.figma.com/file/v5PGfsIW6wfsY0OJLlDPtu/WoT-Project-Prototype?type=design&node-id=0%3A1&t=QdKSb1eO56aEiN51-1",
      img: smartDisplayPreview,
      details: "In this project, our objective was to create an information display specifically designed for students. Our aim was to provide a comprehensive visualization of relevant data pertaining to their lessons, weather updates, and any other information that would be useful to them. We prioritized delivering a user-friendly interface that would enable students to easily access and navigate through the displayed information. Our goal was to enhance the overall student experience and provide a centralized hub for accessing important data."
    }
  ];
  return (
    <section id="projects">
      <h2>Projects</h2>
      <div className="projects-container">
        {projects.map(project => (
          <div key={project.name} onClick={() => setSelectedProject(project)}>
            <h4>{project.name}</h4>
            <img src={project.logo} alt={project.alt} id={project.id} />
          </div>
        ))}
      </div>
      {selectedProject && <ProjectDetails project={selectedProject} onClose={() => setSelectedProject(null)} />}
    </section>
  );
}

export default Projects;